export const SITE_WIDE_ID = 'site_wide';
export const SITE_WIDE_TITLE = 'Site Wide';

export interface Announcement {
  post: string,
  timestamp: string
}

export interface AnnouncementCatalogRef {
  id: string;
  title: string;
}

export interface AnnouncementMongo {
  reachability: 'Students' | 'Instructors' | 'Everyone';
  post: string;
  start_date: string;
  end_date: string;
  catalogs: AnnouncementCatalogRef[];
  created_by?: string;
  edited_by?: string;
  _id?: string;
  deleted?: boolean;
}

export type Catalog = {
  adoptions_have_edit_rights?: boolean;
  assistants?: string[];
  catalog_entry?: boolean;
  current?: boolean;
  enrollment_locked?: boolean;
  instructors?: string[];
  invite_only?: boolean;
  professors?: string[];
  professors_info?: ProfessorsInfo[];
  slug?: string;
  student_count?: number;
  suppress_course_title?: boolean;
  title?: string;
  tmp_sort_key?: string;
  _id?: string;
}

export type ProfessorsInfo = {
  fromDate: string;
  toDate: string;
  institution?: string;
  times?: string[];
  location?: string;
  office_hours?: string;
};
